import { type RouteRecordRaw } from 'vue-router'

// Public guest landing for the parent → Hermes iframe handoff. It runs before
// the user has a session, so it must skip the auth guard; preventAuthenticated-
// Redirect keeps an already-authenticated user from bouncing to home instead of
// completing the handshake.
export const iframeAuthRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/IframeAuthView.vue'),
    meta: {
      isPublic: true,
      preventAuthenticatedRedirect: true,
      title: 'iframe-auth',
    },
    name: 'iframe-auth',
    path: '/iframe-auth',
  },
]
